const SCREEN_NAMES = {
  LOGIN: 'login',
  REGISTER: 'register',
  FORGOT_PASSWORD: 'forgot-password',
  PASSWORD_RESET: 'password-reset',
  EMAIL_UPDATE: 'email-update',
  EMAIL_VERIFY: 'email-verify',
  PC_INFO: 'pc-info',
};

export default SCREEN_NAMES;
